import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"

const ImageCaption = ({ image, caption, position,overline }) => {
  return (
    <>
      <div className={`p0 m0 story--imageCaption-wrapper pos-rel w-100 ${position.toLowerCase()}`}>
        {position.toLowerCase() === "right" && (
          <>
            <div />
            <div className='m-pl20 m-pr20'>
              <div className='story--imageCaption-image pos-rel w-100'>
                <GatsbyImage image={image?.gatsbyImageData} alt='' className='cover w-100' />
              </div>
              <div className='mt10'>
                 
                <span className='small op-50'>{caption}</span>
              </div>
            </div>
          </>
        )}
        {position.toLowerCase() === "left" && (
          <>
            <div className='m-pl20 m-pr20'>
              <div className='story--imageCaption-image pos-rel overflow'>
                <GatsbyImage image={image?.gatsbyImageData} alt='' className='cover' />
              </div>
              <div className='ml10 mt10'>
                 
                <span className='small op-50'>{caption}</span>
              </div>
            </div>
            <div />
          </>
        )}
      </div>
    </>
  )
}

export default ImageCaption
